/**
 * Iter 210 — Device subscription accessor.
 *
 * Anonymous users are identified by a subscriptionId stored in
 * localStorage. Different parts of the app historically wrote this under
 * two keys (`onesignal_sub_id` from the push SDK, and `subscriptionId`
 * from the in-app device subscribe call), so we prefer the OneSignal id
 * but fall back to the local one. If neither exists we mint a fresh
 * client-only UUID so the API has something to attach to.
 */
const SUB_KEY = 'subscriptionId';
const OS_KEY = 'onesignal_sub_id';

function uuid4() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceSubscriptionId() {
  if (typeof window === 'undefined') return '';
  let sub = localStorage.getItem(OS_KEY) || localStorage.getItem(SUB_KEY);
  if (!sub) {
    sub = `web-${uuid4()}`;
    localStorage.setItem(SUB_KEY, sub);
  }
  return sub;
}

export function setDeviceSubscriptionId(sub) {
  if (!sub) return;
  localStorage.setItem(SUB_KEY, sub);
}
